
// components/MailSms/components/TabNavigation.js
import React from 'react';
import * as FiIcons from 'react-icons/fi';

const TabNavigation = ({ tabs, activeTab, onTabChange, isSubTab = false }) => {
  const containerClass = isSubTab 
    ? "bg-gray-50 px-6 py-3 border-b" 
    : "border-b border-gray-200";
  
  const tabClass = isSubTab 
    ? "text-sm font-medium transition-colors" 
    : "py-4 px-2 border-b-2 font-medium text-sm transition-colors";

  return (
    <div className={containerClass}>
      <div className={isSubTab ? "flex space-x-6" : "flex space-x-8 px-6"}>
        {tabs.map(tab => {
          const Icon = typeof tab.icon === 'string' ? FiIcons[tab.icon] : tab.icon;
          const isActive = activeTab === tab.id;
          
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`${tabClass} ${
                isActive
                  ? isSubTab 
                    ? 'text-purple-600' 
                    : 'border-purple-500 text-purple-600'
                  : isSubTab
                    ? 'text-gray-600 hover:text-gray-800'
                    : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
            >
              {Icon && <Icon className="inline mr-2" />}
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TabNavigation;